export default {
    modalQuickActionVariations: {
        title: 'AI ',
        generateWithAi: 'Generera med AI',
        improveWriting: 'Förbättra skrivande',
        fixSpelling: 'Fixa stavning och grammatik',
        simplifyWriting: 'Förenkla skrivandet',
        makeLonger: 'Förläng',
        makeShorter: 'Förkorta',
        replaceText: 'Ersätt text',
        addBelow: 'Lägg till nedanför',
        cancel: 'Avbryt',
        selectQuickActionTitle: 'Berätta för AI vad den ska göra härnäst...',
        regenerate: 'Regenerera',
    },
};
